import config from '@/config'
import axios from '@/libs/api.request'
// 获取签名配置
export const getSignatureConfig = (params) => {
    return axios.request({
        url: 'OfficialAccount/buildConfig',
        method: 'get',
        params: params
    })
}

// 授权接口，传 redirect_uri 为授权成功后跳转的链接  pro
export const Auth = `${config.baseUrl.pro}/OfficialAccount/auth`

// 检查授权状态，授过权就直接返回用户信息，没有授权就跳转授权
export const checkAuth = (params) => {
    return axios.request({
        url: '/OfficialAccount/checkAuth',
        method: 'get',
        params: params
    })
}
